import { RelationshipType } from "@libs/gateways/practice/PracticeGateway.dtos.ts";

export const employerRelationships = [
  RelationshipType.Employer,
  RelationshipType.EmployeeOf
];
